import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";

import { getVlessSubscriptionUrl } from "../../utils/vlessSubscription";

import styles from "./guides.module.css";

const GuideVlessQrData = ({ subscription, label }) => {
  const { t } = useTranslation();
  const hasLabel = (label || "").trim() !== "";
  const resolvedLabel = (label || "").trim() || t("Subscription QR code");
  const subscriptionUrl = getVlessSubscriptionUrl(subscription);

  if (!subscriptionUrl) {
    return null;
  }

  return (
    <div
      className={`${styles.container} ${
        hasLabel ? styles["with-label"] : styles["without-label"]
      }`}
    >
      <div className={styles.row}>
        {hasLabel ? (
          <div className={`${styles.wrap} label mb-025`}>{resolvedLabel}</div>
        ) : (
          <></>
        )}
        <div className={`${styles.qrWrap} center`}>
          <QRCode
            value={subscriptionUrl}
            size={200}
            className={styles.qr}
            aria-label={t("Subscription QR code")}
          />
        </div>
      </div>
    </div>
  );
};

export default GuideVlessQrData;

